/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdLangs200,
  GetApiV1ClassroomdisciplineIdLangs401,
  GetApiV1ClassroomdisciplineIdLangs404,
  GetApiV1ClassroomdisciplineIdLangsPathParams,
  GetApiV1ClassroomdisciplineIdLangsQueryResponse,
} from "../../types/classPlanningLangController/GetApiV1ClassroomdisciplineIdLangs.ts";
import { classroomDisciplineLangItemViewModelSchema } from "../classroomDisciplineLangItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdLangsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdLangs200Schema = z.array(
  z.lazy(() => classroomDisciplineLangItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangs404>;

export const getApiV1ClassroomdisciplineIdLangsQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineIdLangs200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsQueryResponse>;
